<script setup lang="ts">
import { extractStylesheets } from "@modules/event_asset_extractor";
import { listenToEvent } from "@modules/event_hub";
import type { eventWithTime } from "@rrweb/types";
import { onMounted, ref } from "vue";

const props = defineProps<{
  events: eventWithTime[];
}>();

const assets = ref(extractStylesheets(props.events as eventWithTime[]));

const refreshAssets = () => {
  assets.value = extractStylesheets(props.events as eventWithTime[]);
};

onMounted(() => {
  listenToEvent("changed-events", refreshAssets);
  listenToEvent("loaded-events", refreshAssets);
});
</script>

<template>
  <link v-for="asset in assets" :key="asset" rel="preload" as="style" :href="asset" />
</template>
